<template>

  <div>
    <el-form :model="formData" label-width="200px" :rules="rules">
      <el-form-item label="巡检表名称：" prop="star">
        <el-input v-model="formData.patrol_table_name" placeholder="巡检表名称" clearable style="width: 350px">
        </el-input>
      </el-form-item>
        <el-form-item label="巡检设备：">
          <spna>共</spna>
          <spna style="color: #0486fe"> {{formData.device_num}}</spna>
          <span>个设备</span>
        </el-form-item>
      <el-row class="box">
        <el-icon @click="addOnePatrolProject()" color="#0486fe" size="25" style="cursor: pointer;position:absolute;margin-top: 3px;margin-left: -40px"><ElIconCirclePlusFilled /></el-icon>
        <el-col :span="3">序号</el-col> 
        <el-col :span="7">设备名称</el-col>
        <el-col :span="7">规格型号</el-col>
        <el-col :span="6">设备类型</el-col>
      </el-row>
      <el-row v-for="(item,index) in formData.patrolProjectList" :key="index" class="row" :gutter="10"
              style="margin-left: 100px;width: 600px;margin-top: 10px">

        <el-col :span="3" style="text-align: center;">
          <spna>{{ index + 1 }}</spna>
        </el-col>
        <el-col :span="7">
          <el-select v-model="item.device_id" placeholder="设备名称" clearable @change="getDeviceListData(item)">
            <el-option v-for="dict in deviceListAll" :key="dict.value" :label="dict.label"
                       :value="dict.value"></el-option>
          </el-select>
        </el-col>
        <el-col :span="7">
          <el-input v-model="item.model" placeholder="规格型号" disabled></el-input>
        </el-col>
        <el-col :span="7">
          <el-select v-model="item.type_id" placeholder="设备类型" clearable disabled>
            <el-option v-for="dict in deviceTypeAll" :key="dict.value" :label="dict.label"
                       :value="dict.value"></el-option>
          </el-select>
        </el-col>

        <div class="close" @click="removeOnePatrolProject(item.nanoid)">
          <el-icon color="red" size="25"><ElIconRemove /></el-icon>
        </div>
      </el-row>

      <el-form-item>
        <el-button style="margin-top: 20px" type="success" @click="updateRecordConfig" :loading="loading">提交</el-button>
      </el-form-item>
    </el-form>

  </div>
</template>

<script>
import {nanoid} from 'nanoid'

export default {
  name: "EqRecordConfigZhiZaoEdit",
  inject:['$fn'],
  props: {
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    setting: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      loading: false,
      formData: {
        patrol_table_name: '',
        device_num: 1,
        patrolProjectList: [],
      },
      deviceListAll: [],
      deviceTypeAll: [],

      rules: {
        star: [{required: true, message: '', trigger: 'blur'}],
      },
    }
  },
  computed: {},
  methods: {
    addFivePatrolProject() {
      for (let i = 0; i < 1; i++) {
        this.formData.patrolProjectList.push({
          nanoid: nanoid(),
        })
      }
    },
    addOnePatrolProject() {
      this.formData.patrolProjectList.push({
        nanoid: nanoid(),
      })
      this.formData.device_num = this.formData.patrolProjectList.length
    },
    removeOnePatrolProject(nanoid) {
      let index = this.formData.patrolProjectList.findIndex(item => item.nanoid === nanoid);
      this.formData.patrolProjectList.splice(index, 1);
      this.formData.device_num = this.formData.patrolProjectList.length
    },
    async getDeviceTypeAll() {
      await this.$http('eqProjectConfigZhiZaoService.getDeviceTypeAll',{},false).then(data => {
        this.deviceTypeAll = data
      }, errMsg => {
        return this.$message.error(errMsg);
      })
    },
    async getDeviceListAll() {
      await this.$http('eqRecordConfigZhiZaoService.getDeviceListAll',{},false).then(data => {
        this.deviceListAll = data
      }, errMsg => {
        return this.$message.error(errMsg);
      })
    },
    getDeviceListData(item) {
      this.$http('eqRecordConfigZhiZaoService.getDeviceListData',item).then(data => {
        item.model = data.model
        item.type_id = data.type_id
      }, errMsg => {
        return this.$message.error("获取失败"+errMsg);
      })
    },
    getRecordConfigList() {
      this.$http('eqRecordConfigZhiZaoService.getRecordConfig',this.parentData).then(data => {
        this.formData = data
      }, errMsg => {
        return this.$message.error("获取失败"+errMsg);
      })
    },
    updateRecordConfig() {
      if (!this.formData.patrol_table_name) {
        return this.$message.error('巡检表名称不能为空!')
      }
      this.formData.id = this.parentData.id
      this.$http('eqRecordConfigZhiZaoService.updateRecordConfig',this.formData).then(data => {
        this.$fn.closeWindow();
        this.$fn.search();
        return this.$message.success('编辑成功!');
      }, errMsg => {
        return this.$message.error(errMsg);
      })
    }

  }, created() {
    this.addFivePatrolProject()
    this.getDeviceListAll()
    this.getDeviceTypeAll()
    this.getRecordConfigList()

  }
}
</script>

<style scoped>
.box {
  background-color: lightgray;
  height: 35px;
  line-height: 35px;
  text-align: center;
  width: 600px;
  color:black;
  margin-left: 100px

}

.close {
  position: absolute;
  top: 5px;
  margin-left: -40px;
  font-size: 18px;
  cursor: pointer;
}
</style>